import { createStore } from 'vuex';
import axios from 'axios';
import { handleResponseError, merge } from '@/components/helper/util';

const widgetHelper = require('@/scripts/widgetHelper');

const freshPrefix = 'fresh';

const insertAndDeleteUrlParams = function (insertParams, deleteParams = []) {
    if (window && window.location && history.pushState) {
        const searchParams = new URLSearchParams(window.location.search);
        insertParams.forEach((item) => searchParams.set(item.key, item.value));
        deleteParams.forEach((item) => searchParams.delete(item));
        const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + searchParams.toString();
        window.history.pushState({
            path: newurl
        }, '', newurl);
    }
};

const initialByosObj = JSON.parse($('#byosObj').val());
const showBYOSProductsTemplate = $('.showBYOSProducts').html();

const enableGtm = JSON.parse($('.enable_gtm').text());

const gtmFunnelSteps = function (gtmPageMidCategory, gtmPageSubCategory) {
    $('body').trigger('gtm:byosFunnel', [gtmPageMidCategory, gtmPageSubCategory]);
};

function isMobile() {
    return window.matchMedia('only screen and (max-width: 1023px)').matches;
}

export default createStore({
    state: {
        actionURLs: window.vue.actionURLs,
        pdict: {
            ...initialByosObj,
            renderedTemplate: showBYOSProductsTemplate
        },
        svgPath: window.vue.variables.svgPath,
        vueVariables: window.vue.variables || {},
        gridProducts: {},
        currentStage: new URLSearchParams(window.location.search).get('pgId') || 'category' || 'tagsAndRibbons' || 'review',
        tagsAndRibbons: {
            name: '',
            message: '',
            color: initialByosObj.ribbons.length === 1 ? (({ id, value }) => ({ id, value }))(initialByosObj.ribbons[0]) : {},
            tag: initialByosObj.loveTags.length === 1 ? (({ id, value }) => ({ id, value }))(initialByosObj.loveTags[0]) : {},
            noMessage: false
        },
        boxProducts: [],
        sessionStorageObj: JSON.parse(window.sessionStorage.getItem(`${freshPrefix}_selectedProductData`))
    },
    getters: {
        pdict(state) {
            return state.pdict;
        },
        gridProducts(state) {
            return state.gridProducts;
        },
        currentStage(state) {
            return state.currentStage;
        },
        boxProducts(state) {
            return state.boxProducts;
        },
        subTotalValue(state) {
            if (state.boxProducts.length > 0) {
                const totalPriceValue = state.boxProducts.reduce((total, product) => total + parseFloat(product.priceValue * product.qty), 0);
                return state.pdict.currencyFormat.replace(state.pdict.currencyFormatValuePlaceholder, totalPriceValue.toFixed(2));
            }
            return state.pdict.currencyFormat.replace(state.pdict.currencyFormatValuePlaceholder, '0' + state.pdict.currencyDecimalSeparator + '00');
        },
        totalAddedProducts(state) {
            return state.boxProducts.reduce((total, product) => total + product.qty, 0);
        },
        tagsAndRibbons(state) {
            return state.tagsAndRibbons;
        },
        sessionStorageObj(state) {
            return state.sessionStorageObj;
        }
    },
    mutations: {
        updateVuexWithByosSessionStorageData(state) {
            if (state.sessionStorageObj) {
                state.boxProducts = state.sessionStorageObj.boxProducts;
                state.tagsAndRibbons = state.sessionStorageObj.tagsAndRibbons;
            }
        },
        updateVuexWithEditBox(state, data) {
            state.boxProducts = data.boxProducts;
            state.tagsAndRibbons = data.tagsAndRibbons;
        },
        setByosSessionStorage(state) {
            const sessionStorageObjString = JSON.stringify({
                boxProducts: state.boxProducts,
                tagsAndRibbons: state.tagsAndRibbons,
                currentSite: state.vueVariables.currentSite
            });

            state.sessionStorageObj = JSON.parse(sessionStorageObjString);
            window.sessionStorage.setItem(`${freshPrefix}_selectedProductData`, sessionStorageObjString);
        },
        removeByosSessionStorage(state) {
            state.sessionStorageObj = null;
            window.sessionStorage.removeItem(`${freshPrefix}_selectedProductData`);
        },
        setPdict(state, data) {
            state.pdict = data;
        },
        setPdictField(state, data) {
            state.pdict[data.fieldName] = data.fieldValue;
        },
        updatePdict(state, data) {
            state.pdict = merge(state.pdict, data);
        },
        setGridProduct(state, data) {
            state.gridProducts[data.fieldName] = data.fieldValue;
        },
        addProduct(state, product) {
            const productIndex = state.boxProducts.findIndex((boxProduct) => boxProduct.id === product.id);
            if (productIndex >= 0) {
                state.boxProducts[productIndex].qty += product.qty;
            } else {
                state.boxProducts.push(product);
            }
        },
        removeProduct(state, productId) {
            state.boxProducts = state.boxProducts.map((product) => {
                if (product.id === productId) {
                    if (!(product.qty - 1)) {
                        $(`.product[data-pid="${productId}"]`).find('.add-to-box').data('product-added', 'false');
                    }
                    Object.assign(product, {
                        qty: product.qty - 1
                    });
                }
                return product;
            }).filter((product) => product.qty);
        },
        setCurrentStage(state, data) {
            state.currentStage = data;
        },
        setTagsAndRibbons(state, data) {
            state.tagsAndRibbons[data.fieldName] = data.fieldValue;
        },
        setVueVariables(state, data) {
            state.vueVariables = { ...state.vueVariables, ...data };
        }
    },
    actions: {
        removeBYOSStorageOnSiteChange({ commit, state }) {
            if (state.sessionStorageObj) {
                if (state.vueVariables.currentSite !== state.sessionStorageObj.currentSite) {
                    commit('removeByosSessionStorage');
                }
            }
        },

        wrapByosGift({ commit, state, dispatch }, payload) {
            const apiString = `${state.actionURLs['Cart-AddProductsToBox']}`;
            const giftKeyUID = state.pdict.giftKey || `giftKey_${Math.random().toString(36).substr(2, 4)}`;
            const dataToSend = {};
            dataToSend[giftKeyUID] = {
                products: state.boxProducts.map((product) => ({
                    productId: product.id,
                    quantity: product.qty,
                    productName: product.name,
                    productImageUrl: product.image,
                    productPrice: product.price,
                    productPriceValue: product.priceValue
                })),
                giftValues: {
                    boxName: state.tagsAndRibbons.name,
                    loveTag: state.tagsAndRibbons.tag,
                    ribbon: state.tagsAndRibbons.color,
                    giftMessage: state.tagsAndRibbons.message,
                    noMessage: state.tagsAndRibbons.noMessage
                },
                giftKey: giftKeyUID,
                categoryId: 'byos'
            };

            var form = {
                boxJson: JSON.stringify(dataToSend),
                action: state.pdict.action === 'edit' ? 'edit' : '',
                giftKey: state.pdict.giftKey
            };

            form[state.vueVariables.csrfTokenName] = state.vueVariables.csrfTokenValue;

            var formData = new FormData();

            Object.keys(form).forEach((property) => {
                formData.append(property, form[property]);
            });

            $('body').spinner().start();

            return axios({
                method: 'post',
                url: apiString,
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then((response) => {
                    const data = response.data;

                    if (data.error) {
                        widgetHelper.createError(data.message);
                        $('body').spinner().stop();
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    $('.minicart').trigger('count:update', data);
                    $('body').trigger('product:afterAddToCart', data);
                    if (isMobile()) {
                        window.EventEmitter?.emit('toast:show', {
                            type: 'info',
                            template: 'addToCartToast'
                        });
                    }
                    window.EventEmitter?.emit('miniCart:update', data.cart);
                    window.EventEmitter?.emit('byos:addToCart', data);
                    data.event = payload.event;
                    document.dispatchEvent(new CustomEvent('update-cart', { detail: data }));
                    if (enableGtm) {
                        data.pageContext = 'BYOS';
                        gtmFunnelSteps('Confirmation', '');
                        $('body').trigger('gtm:addtocart', data);
                    }
                    commit('setCurrentStage', 'success');
                    commit('removeByosSessionStorage');
                    $('body').spinner().stop();

                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return {
                        success: true
                    };
                })
                .catch((error) => {
                    $('body').spinner().stop();
                    handleResponseError(commit, dispatch, error.response);
                    window.EventEmitter?.emit('toast:show', {
                        type: 'error',
                        message: error.response.data.message
                    });
                });
        },
        // eslint-disable-next-line no-unused-vars
        onSetCurrentStage({ commit, state }, currentStage) {
            commit('setCurrentStage', currentStage);
            if (currentStage === 'category') {
                document.dispatchEvent(new CustomEvent('search:DOMUpdated'));
            }

            const deleteParams = [];
            const insertParams = [{
                key: 'pgId',
                value: currentStage
            }];

            insertAndDeleteUrlParams(insertParams, deleteParams);

            if (enableGtm) {
                switch (currentStage) {
                    case 'tagsAndRibbons':
                        gtmFunnelSteps('Tags & Ribbons', '');
                        break;
                    case 'review':
                        gtmFunnelSteps('Review', '');
                        break;
                    default:
                        gtmFunnelSteps('Category', '');
                }
            }

            $('html, body').animate({
                scrollTop: $('body').scrollTop()
            });
        },
        getBoxToEdit({ commit, state, dispatch }) {
            const apiString = `${state.actionURLs['BYOS-GetBoxToEdit']}`;

            return axios({
                method: 'get',
                url: apiString,
                params: Object.fromEntries(new URLSearchParams(window.location.search))
            })
                .then((response) => {
                    const data = response.data;

                    if (data.error) {
                        // eslint-disable-next-line no-throw-literal
                        throw { response };
                    }

                    commit('updateVuexWithEditBox', data.boxToEdit);

                    return {
                        success: true
                    };
                })
                .catch((error) => handleResponseError(commit, dispatch, error.response));
        }
    }
});
